import { useEffect, useState } from 'react';

import CreatePeriodReportModal from '../Modals/createPeriodReportModal/CreatePeriodReportModal';

import useScreenSize from 'hooks/Screen/useScreenSize';
import useGetPeriodReportList from 'hooks/PeriodReports/useGetPeriodReports';
import { useGetPeriodReportsColumns } from 'hooks/PeriodReports/useGetPeriodReportsColumns';
import AdvancedFilterDataTable from 'components/FilterDataTable/AdvancedFilterDataTable';
import { PeriodReportListItem } from 'api/periodReports/type';
import PeriodReportExpandable from 'components/VisitsAndScheduledTasks/PeriodReportsExpandable';

interface PeriodReportsPageProps {
  slug: string;
}

const PeriodReportsPage: React.FC<PeriodReportsPageProps> = ({ slug }) => {
  const [page, setPage] = useState(1);
  const [ordering, setQueryParam] = useState('');
  const [search, setSearch] = useState('');
  const { isNotDesktop } = useScreenSize();
  const { data, isLoading, refetch } = useGetPeriodReportList({ slug: slug || '', enabled: false });
  const columns = useGetPeriodReportsColumns();
  const searchFields = ['call_date', 'start_date', 'end_date'];

  useEffect(() => {
    refetch();
  }, [page, ordering, search, refetch]);

  return (
    <div className="bg-white">
      <AdvancedFilterDataTable<PeriodReportListItem>
        columns={columns}
        amountPerPageLabel="Reports Per Page"
        data={data || []}
        onChangePage={setPage}
        onChangeFilterParams={setQueryParam}
        onChangeSearch={setSearch}
        searchFields={searchFields}
        isLoading={isLoading}
        expandableRows={isNotDesktop}
        expandableRowsComponent={PeriodReportExpandable}
        isNotReportsTable={false}
      />
      <CreatePeriodReportModal refetchPeriodReports={refetch} />
    </div>
  );
};

export default PeriodReportsPage;
